import { createSelector } from '@ngrx/store';
import { ViewColumn } from '../../../view-column';
import { AppStates } from '../states';

export const selectViewColState = (state: AppStates) => state.viewColState;
export const selectFirstColComp = (state: AppStates) => state.viewColState.firstColumn;
export const selectSecondColComp = (state: AppStates) => state.viewColState.secondColumn;
export const selectViewCols = (state: AppStates) => state.viewColState.viewCol;
export const selectBreadCrumbs = (state: AppStates) => state.viewColState.breadCrumbs;
export const selectLeftDrawer = (state: AppStates) => state.viewColState.leftDrawer;
export const selectRightDrawer = (state: AppStates) => state.viewColState.rightDrawer;
export const selectSingleColumn = (state: AppStates) => state.viewColState.singleColumn;
export const selectLocalState = (state: AppStates, index: number) => state.viewColState.viewCol[index]?.localState;
export const selectPrevIndex = (state: AppStates) => state.viewColState.prevIndex;

export const selectPrevLocalState = createSelector(
  selectViewCols,
  selectPrevIndex,
  (s1: ViewColumn[], s2: number) => s1[s2]?.localState
);
